import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ORDER_STATUSES = [
  "received",
  "diagnosis",
  "waiting_parts",
  "maintenance",
  "software_test",
  "ready",
  "delivered",
  "warranty"
];

export const STATUS_LABELS = {
  received: "Recibido",
  diagnosis: "En Diagnóstico",
  waiting_parts: "Esperando Refacción",
  maintenance: "En Mantenimiento",
  software_test: "Pruebas de Software",
  ready: "Listo para Entrega",
  delivered: "Entregado",
  warranty: "En Garantía"
};

export const STATUS_COLORS = {
  received: "status-received",
  diagnosis: "status-diagnosis",
  waiting_parts: "status-waiting_parts",
  maintenance: "status-maintenance",
  software_test: "status-software_test",
  ready: "status-ready",
  delivered: "status-delivered",
  warranty: "status-warranty"
};

export const EQUIPMENT_TYPES = [
  "Laptop",
  "PC de Escritorio",
  "MacBook",
  "iMac",
  "Mac Mini",
  "All-in-One",
  "Servidor",
  "Monitor",
  "Impresora",
  "Otro"
];

export const SERVICE_CATEGORIES = {
  preventive: "Mantenimiento Preventivo",
  software: "Soporte de Software",
  hardware: "Reparación de Hardware"
};

export const COMMON_ACCESSORIES = [
  "Cargador/Adaptador",
  "Mouse",
  "Teclado",
  "Cable de poder",
  "Maletín/Funda",
  "USB/Pendrive",
  "Disco externo",
  "Monitor adicional",
  "Auriculares",
  "Webcam"
];

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('es-MX', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);
}

export function getWhatsAppLink(phone, message = "") {
  const cleanPhone = phone.replace(/\D/g, '');
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${cleanPhone}${message ? `?text=${encodedMessage}` : ''}`;
}
